export const ru = {
    'condition-type-all': 'Выполнены все',
    'condition-type-not': 'Не выполнено ни одного',
    'condition-type-or': 'Выполнено хотя бы одно',
    'day-description': {
        one: 'за {count} день',
        some: 'за {count} дня',
        many: 'за {count} дней',
        none: 'за {count} дней'
    },
    'no-metrika-goal-value': 'Цель не найдена',
    'no-segment-value': 'Сегмент не найден',
    'single-bet-data-set-none':
        'Ставки не были применены ни к одному условию ретаргетинга',
    'single-bet-data-set-success':
        'Новые ставки успешно установлены для {setCount} условий ретаргетинга из {retargetingsCount}. Активация займёт около 30 минут.',
    'single-rate-max-price':
        'Единая ставка не должна быть больше {maxValue} {currency}',
    'single-rate-min-price':
        'Единая ставка не должна быть меньше {minValue} {currency}',
    'status-active': 'Активно',
    'status-stopped': 'Остановлено'
};
